export enum NotificationType {
  UnreadWhatsApp = 'UnreadWhatsapp',
  UnActionedQaFindings = 'UnActionedQaFindings',
  ProjectsApproachingLockdown = 'ProjectsApproachingLockdown',
  PaymentInProgress = 'PaymentInProgress',
  PaymentItemResubmissionCount = 'PaymentItemResubmissionCount',
}
